module.exports = __webpack_public_path__ + "img/media_reg_3.03fa188c.png";